import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { creditsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const CreditsContext = createContext({ credits: null, refreshCredits: async () => {} });

export function CreditsProvider({ children }) {
  const { user } = useAuth();
  const userId = user?.id;
  const isSuperAdmin = user?.role === 'super_admin';
  const [credits, setCredits] = useState(null);
  const requestIdRef = useRef(0);

  const refreshCredits = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    try {
      const res = await creditsAPI.getBalance();
      if (requestId !== requestIdRef.current) return; // stale response
      setCredits(res.data.credits || null);
    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      // Non-critical: hide the number rather than show a wrong 0
      setCredits(null);
    }
  }, []);

  useEffect(() => {
    setCredits(null);
    if (userId && !isSuperAdmin) {
      refreshCredits();
    } else {
      requestIdRef.current += 1; // invalidate any in-flight request
    }
  }, [userId, isSuperAdmin, refreshCredits]);

  return (
    <CreditsContext.Provider value={{ credits, refreshCredits }}>
      {children}
    </CreditsContext.Provider>
  );
}

export const useCredits = () => useContext(CreditsContext);
